import { Button } from '@/components/ui/button';
import { useAdminNavigation } from '@/contexts/AdminNavigationContext';
import { useAuth } from '@/contexts/AuthContext';

import MobileAdminNavbar from './AdminNavbarMobile';

const AdminHeader = () => {
  const { tabs, activeTab, setActiveTab } = useAdminNavigation();
  const { signOut, user } = useAuth();

  const handleSignOut = async () => {
    await signOut();
  };

  return (
    <header
      className="sticky top-0 z-50 bg-background border-b flex items-center justify-between min-h-16 px-4 sm:px-6 lg:px-8 py-2"
      data-admin-internal
    >
      <Button
        variant="link"
        className="flex-shrink-0 p-0 hover:no-underline text-lg font-bold text-foreground"
        onClick={() => setActiveTab?.('dashboard')}
      >
        <h1>Estancia Corta</h1>
      </Button>

      <div className="flex items-center gap-4">
        <MobileAdminNavbar
          tabs={tabs}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          user={user}
          onSignOut={handleSignOut}
        />
      </div>
    </header>
  );
};

export default AdminHeader;
